import { AlarmModeEnum, BatteryStoreModeEnum, DroneBatteryModeEnum, LinkWorkModeEnum } from '/@/types/airport-tsa'
// 스테이션(독) 명령어 세트
export enum DeviceCmd {
  // 간단 명령어
  DebugModeOpen = 'debug_mode_open', // 디버그 모드 켜기
  DebugModeClose = 'debug_mode_close', // 디버그 모드 끄기
  SupplementLightOpen = 'supplement_light_open', // 보조등 켜기
  SupplementLightClose = 'supplement_light_close', // 보조등 끄기
  ReturnHome = 'return_home', // 원클릭 리턴 투 홈(RTH)
  ReturnHomeCancel = 'return_home_cancel', // 리턴 투 홈 취소
  // 복합 명령어
  DeviceReboot = 'device_reboot', // 스테이션 재부팅
  DroneOpen = 'drone_open', // 드론 전원 켜기
  DroneClose = 'drone_close', // 드론 전원 끄기
  // DeviceCheck = 'device_check', // 원클릭 점검 (이륙 전 자가 진단)
  DeviceFormat = 'device_format', // 스테이션 데이터 초기화
  DroneFormat = 'drone_format', // 드론 데이터 초기화
  CoverOpen = 'cover_open', // 커버 열기
  CoverClose = 'cover_close', // 커버 닫기
  PutterOpen = 'putter_open', // 푸시로드 전개
  PutterClose = 'putter_close', // 푸시로드 수축
  ChargeOpen = 'charge_open', // 충전 시작
  ChargeClose = 'charge_close', // 충전 중지
  AlarmStateSwitch = 'alarm_state_switch', // 스테이션 시청각 알람
  BatteryStoreModeSwitch = 'battery_store_mode_switch', // 배터리 관리
  DroneBatteryModeSwitch = 'battery_maintenance_switch', // 드론 배터리 관리
  SdrWorkModeSwitch = 'sdr_workmode_switch', // 강화 영상 전송
}

export type DeviceCmdItemAction = AlarmModeEnum | BatteryStoreModeEnum | DroneBatteryModeEnum | LinkWorkModeEnum

export interface DeviceCmdItem{
  label: string, // 제목
  status: string, // 현재 상태
  operateText: string, // 버튼 텍스트
  cmdKey: DeviceCmd, // 请求指令
  oppositeCmdKey?: DeviceCmd, // 相反状态指令
  action?: DeviceCmdItemAction, // 参数
  func: string, // 处理函数
  loading: boolean // 按钮loading
  disabled?: boolean // 按钮disabled
}
export const noDebugCmdList: DeviceCmdItem[] = [
  {
    label: 'Return Home',
    status: '--',
    operateText: 'Return Home',
    cmdKey: DeviceCmd.ReturnHome,
    func: 'returnHome',
    loading: false,
  },
  {
    label: 'Return Home Cancel',
    status: '--',
    operateText: 'Return Home Cancel',
    cmdKey: DeviceCmd.ReturnHomeCancel,
    func: 'returnHomeCancel',
    loading: false,
  }
]

// 스테이션 명령어
export const cmdList: DeviceCmdItem[] = [
  {
    // iconName: ,
    label: '스테이션 시스템',
    status: '작동 중',
    operateText: '재부팅',
    cmdKey: DeviceCmd.DeviceReboot,
    func: 'deviceReboot',
    loading: false,
    // btnAnimationIconName: '',
    // operateTips: '',
    // statusColor: '',
  },
  {
    label: '드론',
    status: '전원 꺼짐',
    operateText: '전원 켜기',
    cmdKey: DeviceCmd.DroneOpen,
    oppositeCmdKey: DeviceCmd.DroneClose,
    func: 'droneStatus',
    loading: false,
  },
  {
    label: '커버',
    status: '닫힘',
    operateText: '열기',
    cmdKey: DeviceCmd.CoverOpen,
    oppositeCmdKey: DeviceCmd.CoverClose,
    func: 'coverStatus',
    loading: false,
  },
  {
    label: '푸시로드',
    status: '수축됨',
    operateText: '전개',
    cmdKey: DeviceCmd.PutterOpen,
    oppositeCmdKey: DeviceCmd.PutterClose,
    func: 'putterStatus',
    loading: false,
  },
  {
    label: '충전 상태',
    status: '충전 중 아님',
    operateText: '충전',
    cmdKey: DeviceCmd.ChargeOpen,
    oppositeCmdKey: DeviceCmd.ChargeClose,
    func: 'chargeStatus',
    loading: false,
  },
  {
    label: '스테이션 저장소',
    status: '--',
    operateText: '초기화',
    cmdKey: DeviceCmd.DeviceFormat,
    func: 'deviceFormat',
    loading: false,
  },
  {
    label: '드론 저장소',
    status: '--',
    operateText: '초기화',
    cmdKey: DeviceCmd.DroneFormat,
    func: 'droneFormat',
    loading: false,
  },
  {
    label: '보조등',
    status: '꺼짐',
    operateText: '켜기',
    cmdKey: DeviceCmd.SupplementLightOpen,
    oppositeCmdKey: DeviceCmd.SupplementLightClose,
    func: 'supplementLightStatus',
    loading: false,
  },
  {
    label: '스테이션 시청각 알람',
    status: '꺼짐',
    operateText: '켜기',
    cmdKey: DeviceCmd.AlarmStateSwitch,
    action: AlarmModeEnum.OPEN,
    func: 'alarmState',
    loading: false,
  },
  {
    label: '스테이션 배터리 보관 모드',
    status: '예약',
    operateText: '비상',
    cmdKey: DeviceCmd.BatteryStoreModeSwitch,
    action: BatteryStoreModeEnum.BATTERY_EMERGENCY_STORE,
    func: 'batteryStoreMode',
    loading: false,
  },
  {
    label: '드론 배터리 관리',
    status: '--',
    operateText: '관리 시작',
    cmdKey: DeviceCmd.DroneBatteryModeSwitch,
    action: DroneBatteryModeEnum.OPEN,
    func: 'droneBatteryMode',
    loading: false,
    disabled: true,
  },
  {
    label: '4G 강화',
    status: '--',
    operateText: '켜기',
    cmdKey: DeviceCmd.SdrWorkModeSwitch,
    action: LinkWorkModeEnum.FourG_FUSION_MODE,
    func: 'sdrWorkMode',
    loading: false,
  },
]

export enum DeviceCmdStatusText {
  DeviceRebootNormalText = '작동 중',
  DeviceRebootInProgressText = '재부팅 중...',
  DeviceRebootFailedText = '재부팅 실패',

  DroneStatusOpenNormalText = '켜짐',
  DroneStatusOpenInProgressText = '전원 켜지는 중...',
  DroneStatusOpenFailedText = '꺼짐',
  DroneStatusOpenBtnText = '전원 끄기',

  DroneStatusCloseNormalText = '꺼짐',
  DroneStatusCloseInProgressText = '전원 꺼지는 중...',
  DroneStatusCloseFailedText = '켜짐',
  DroneStatusCloseBtnText = '전원 켜기',

  DeviceCoverOpenNormalText = '열림',
  DeviceCoverOpenInProgressText = '여는 중...',
  DeviceCoverOpenFailedText = '닫힘',
  DeviceCoverOpenBtnText = '닫기',

  DeviceCoverCloseNormalText = '닫힘',
  DeviceCoverCloseInProgressText = '닫는 중...',
  DeviceCoverCloseFailedText = '열림',
  DeviceCoverCloseBtnText = '열기',

  DevicePutterOpenNormalText = '전개됨',
  DevicePutterOpenBtnText = '수축',
  DevicePutterOpenInProgressText = '푸시로드 전개 중',
  DevicePutterOpenFailedText = '수축됨',

  DevicePutterCloseNormalText = '수축됨',
  DevicePutterCloseInProgressText = '푸시로드 수축 중',
  DevicePutterCloseFailedText = '전개됨',
  DevicePutterCloseBtnText = '전개',

  DeviceChargeOpenNormalText = '충전 중',
  DeviceChargeOpenInProgressText = '충전 중...',
  DeviceChargeOpenFailedText = '충전 중 아님',
  DeviceChargeOpenBtnText = '충전 중단',

  DeviceChargeCloseNormalText = '충전 중단',
  DeviceChargeCloseInProgressText = '충전 중단 중...',
  DeviceChargeCloseFailedText = '충전 중',
  DeviceChargeCloseBtnText = '충전 시작',

  DeviceFormatInProgressText = '초기화 중...',
  DeviceFormatFailedText = '초기화 실패',

  DroneFormatInProgressText = '초기화 중...',
  DroneFormatFailedText = '초기화 실패',

  DeviceSupplementLightOpenNormalText = '켜짐',
  DeviceSupplementLightOpenInProgressText = '켜지는 중...',
  DeviceSupplementLightOpenFailedText = '꺼짐',
  DeviceSupplementLightOpenBtnText = '끄기',

  DeviceSupplementLightCloseNormalText = '꺼짐',
  DeviceSupplementLightCloseText = '끄는 중...',
  DeviceSupplementLightCloseFailedText = '켜짐',
  DeviceSupplementLightCloseBtnText = '켜기',

  AlarmStateOpenNormalText = '켜짐',
  AlarmStateOpenText = '켜지는 중...',
  AlarmStateOpenFailedText = '꺼짐',
  AlarmStateOpenBtnText = '끄기',

  AlarmStateCloseNormalText = '꺼짐',
  AlarmStateCloseText = '끄는 중...',
  AlarmStateCloseFailedText = '켜짐',
  AlarmStateCloseBtnText = '켜기',

  BatteryStoreModePlanNormalText = '예약',
  BatteryStoreModePlanText = '전환 중...',
  BatteryStoreModePlanFailedText = '비상',
  BatteryStoreModePlanBtnText = '비상',

  BatteryStoreModeEmergencyNormalText = '비상',
  BatteryStoreModeEmergencyText = '전환 중...',
  BatteryStoreModeEmergencyFailedText = '예약',
  BatteryStoreModeEmergencyBtnText = '예약',

  DroneBatteryModeMaintenanceInProgressText = '관리 중',
  DroneBatteryModeMaintenanceNotNeedText = '관리 필요 없음',
  DroneBatteryModeMaintenanceNeedText = '관리 필요',
  DroneBatteryModeOpenBtnText = '관리 시작',
  DroneBatteryModeCloseBtnText = '관리 종료',

  SdrWorkModeFourGOpenNormalText = '켜짐',
  SdrWorkModeFourGOpenText = '켜지는 중...',
  SdrWorkModeFourGOpenFailedText = '--',
  SdrWorkModeFourGOpenBtnText = '끄기',

  SdrWorkModeFourGCloseNormalText = '--',
  SdrWorkModeFourGCloseText = '끄는 중...',
  SdrWorkModeFourGCloseFailedText = '켜짐',
  SdrWorkModeFourCloseBtnText = '켜기',
}

// 명령어 실행 상태
export enum DeviceCmdExecuteStatus {
  Sent = 'sent', // 배포됨
  InProgress = 'in_progress', // 실행 중
  OK = 'ok', // 실행 성공
  Failed = 'failed', // 실패
  Canceled = 'canceled', // 취소됨
  Timeout = 'timeout' // 시간 초과
}

export interface DeviceCmdExecuteInfo {
  biz_code: string,
  timestamp: number,
  sn: string,
  bid: string,
  output:{
    status: DeviceCmdExecuteStatus,
    progress?: {
      percent: number,
      step_key: string,
      step_result: number
    },
    ext?: {
      rate?: number
    }
  }
  result: number,
}

// 所有机场的指令执行状态
export interface DevicesCmdExecuteInfo {
  [key: string]: DeviceCmdExecuteInfo[], // sn --- DeviceCmdExecuteInfo
}
